import React from 'react';
import {Dropdown, Input, Layout, Menu} from 'antd';
import './index.style.less';
import {FiMoreVertical} from 'react-icons/fi';
import AppLogo from '../components/AppLogo';

import AppNotifications from '../../AppNotifications';
import UserInfo from '../components/UserInfo';
import {useTranslation} from 'react-i18next';

const AppHeader = () => {
  const {Header} = Layout;
  const {Search} = Input;
  const {t} = useTranslation();

  const menuMobile = (
    <Menu>
      <AppNotifications />
    </Menu>
  );

  return (
    <Header className='app-userMiniHeader'>
      <AppLogo />

      <Search
        className='userMiniHeader-search'
        placeholder={t('int-enter-search-text')}
      />
      <div className='app-userMiniHeader-sectionDesktop'>
        <AppNotifications />
      </div>
      <UserInfo />
      <div className='app-userMiniHeader-section-mobile'>
        <Dropdown overlay={menuMobile} trigger={['click']}>
          <a className='ant-dropdown-link' onClick={(e) => e.preventDefault()}>
            <FiMoreVertical />
          </a>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader;

AppHeader.propTypes = {};
